import { API_URL } from '../config/api';
import { tokenManager } from '../context/AuthContext';
import { parseResponse, downloadBlob, toQuery } from './expenseVouchersApi';

// API client for the Expense approval workflow (Phase 3).
// Who may do what is decided by the server from the signed-in user, AccessProvisioning and
// the voucher's approver snapshot; the UI only shows the actions the server reports.

const BASE = '/expenses/approvals';

const request = async (method, path, body) => parseResponse(await fetch(`${API_URL}${path}`, {
  method,
  headers: { ...tokenManager.getAuthHeader(), 'Content-Type': 'application/json' },
  ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
}));

export const STAGE_META = {
  ACCOUNTS: { label: 'Accounts review', color: 'info' },
  APPROVERS: { label: 'With approvers', color: 'secondary' },
  BLOCKED: { label: 'Blocked: inactive approver', color: 'error' },
  APPROVED: { label: 'Approved', color: 'success' },
  REJECTED: { label: 'Rejected', color: 'error' },
  SENT_BACK: { label: 'Sent back', color: 'warning' },
  DRAFT: { label: 'Draft', color: 'default' },
};

export const MAX_COMMENT = 500;

export const approvalsApi = {
  list: (params) => request('GET', `${BASE}${toQuery(params)}`),
  get: (id) => request('GET', `${BASE}/${id}`),
  route: (id, { version, option, note }) => request('POST', `${BASE}/${id}/route`, { version, option, note }),
  approve: (id, { version, group, note }) => request('POST', `${BASE}/${id}/approve`, { version, group, note }),
  reject: (id, { version, reason }) => request('POST', `${BASE}/${id}/reject`, { version, reason }),
  sendBack: (id, { version, comment }) => request('POST', `${BASE}/${id}/send-back`, { version, comment }),
  downloadBill: (id, bill) => downloadBlob(`${API_URL}${BASE}/${id}/bills/${bill._id}`, bill.originalName),
};
